import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH

export default {
  // 积分商城列表
  giftGetList(data) {
    const params = data
    return request({
      url: urlParams + '/gift/getList',
      type: 'get',
      params: params
    })
  }, 
  // 积分商城添加
  giftAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/gift/addUpd',
      type: 'post',
      params: params,
      qs:false
    })
  },
  // 积分商城删除
  giftDel(data) {
    const params = data
    return request({
      url: urlParams + '/gift/del',
      type: 'post',
      params: params,
    })
  },
  // 积分商城详情
  giftDetail(data) {
    const params = data
    return request({
      url: urlParams + '/gift/detail',
      type: 'get',
      params: params
    })
  },
  giftUpdStatus(data) {
    const params = data
    return request({
      url: urlParams + '/gift/updStatus',
      type: 'post',
      params: params,
    })
  },

  // 积分商城订单列表
  giftOrderGetList(data) {
    const params = data
    return request({
      url: urlParams + '/gift-order/getList',
      type: 'get',
      params: params
    })
  },

  //积分商城订单详情
  giftOrderDetail(data) {
    const params = data
    return request({
      url: urlParams + '/gift-order/detail',
      type: 'get',
      params: params
    })
  },
}